<template>
  <div>
    <!-- 选择客户弹窗 -->
    <Drawer :title="$t('选择客户')" :visible="isShowCustomer" size="1200px" @confirm="confirmDrawer" @closed="closeDrawer">
      <el-form :model="searchCustomerData.model" class="form-inline-drawer mb-0-5" label-position="top">
        <el-row>
          <el-col :span="8">
            <el-form-item :label="$t('客户编码')">
              <el-input v-model="searchCustomerData.model.code" :placeholder="$t('请输入')" clearable class="inputWidth" @keyup.enter.native="searchCustomer" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('客户名称')">
              <el-input v-model="searchCustomerData.model.name" :placeholder="$t('请输入')" clearable class="inputWidth" @keyup.enter.native="searchCustomer" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item v-if="isShowCustomerMore" :label="$t('客户分组')">
              <el-input v-model="searchCustomerData.model.groupName" :placeholder="$t('请输入')" clearable class="inputWidth" @keyup.enter.native="searchCustomer" />
            </el-form-item>
            <el-form-item v-if="!isShowCustomerMore">
              <div class="inputWidth d-flex justify-end" style="margin-top: 32px">
                <el-button v-preventReClick type="primary" @click="searchCustomer">
                  {{ $t('查询') }}
                </el-button>
                <el-button v-preventReClick type="default" @click="resetCustomer">
                  {{ $t('重置') }}
                </el-button>
                <el-button type="default" style="margin-right: 0" @click="isShowCustomerMore = !isShowCustomerMore">
                  {{ $t('更多') }}
                  <i class="el-icon-arrow-down"></i>
                </el-button>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="isShowCustomerMore">
          <el-col :span="8">
            <el-form-item v-if="isShowCustomerMore" :label="$t('业务员')">
              <el-input v-model="searchCustomerData.model.businessPerson" :placeholder="$t('请输入')" clearable class="inputWidth" @keyup.enter.native="searchCustomer" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item v-if="isShowCustomerMore" :label="$t('描述')">
              <el-input v-model="searchCustomerData.model.content" :placeholder="$t('请输入')" clearable class="inputWidth" @keyup.enter.native="searchCustomer" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item>
              <div class="inputWidth d-flex justify-end" style="margin-top: 32px">
                <el-button v-preventReClick type="primary" @click="searchCustomer">
                  {{ $t('查询') }}
                </el-button>
                <el-button v-preventReClick type="default" @click="resetCustomer">
                  {{ $t('重置') }}
                </el-button>
                <el-button type="default" style="margin-right: 0" @click="isShowCustomerMore = !isShowCustomerMore">
                  {{ $t('收起') }}
                  <i class="el-icon-arrow-up"></i>
                </el-button>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <vxe-grid
        ref="tableRefCustomer"
        border
        highlight-hover-row
        highlight-current-row
        resizable
        keep-source
        show-overflow
        show-header-overflow
        :loading="customerLoading"
        cell-class-name="c-class-style"
        header-row-class-name="h-class-style"
        :columns="tableCustomerColumn"
        :data="tableCustomerData.records"
        @cell-click="handleCustomerClick"
      >
        <template #empty>
          <el-empty :image="require('@/assets/404_images/no-data-small.png')" :description="$t('暂无数据')" />
        </template>
      </vxe-grid>
      <pagination
        v-show="tableCustomerData.total > 0"
        :limit.sync="searchCustomerData.size"
        :page.sync="searchCustomerData.current"
        :total="Number(tableCustomerData.total)"
        :popper-class="'select_bottom'"
        @pagination="fetchCustomerList"
      />
    </Drawer>
    <Drawer :title="$t('选择坯布')" :visible="isShowFabric" class="drawer" size="1200px" @confirm="confirmDrawer" @closed="closeDrawer">
      <el-form :model="searchFabricData.model" class="form-inline-drawer mb-0-5" label-position="top">
        <el-row>
          <el-col :span="8">
            <el-form-item :label="$t('坯布号')">
              <el-input v-model="searchFabricData.model.code" :placeholder="$t('请输入')" clearable class="inputWidth" @keyup.enter.native="searchFabric" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('坯布品名')">
              <el-input v-model="searchFabricData.model.name" :placeholder="$t('请输入')" clearable class="inputWidth" @keyup.enter.native="searchFabric" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item v-if="isShowFabricMore" :label="$t('成分')">
              <el-input v-model="searchFabricData.model.component" :placeholder="$t('请输入')" clearable class="inputWidth" @keyup.enter.native="searchFabric" />
            </el-form-item>
            <el-form-item v-if="!isShowFabricMore">
              <div class="inputWidth d-flex justify-end" style="margin-top: 32px">
                <el-button v-preventReClick type="primary" @click="searchFabric">
                  {{ $t('查询') }}
                </el-button>
                <el-button v-preventReClick type="default" @click="resetFabric">{{ $t('重置') }}</el-button>
                <el-button type="default" style="margin-right: 0" @click="isShowFabricMore = !isShowFabricMore">
                  {{ $t('更多') }}
                  <i class="el-icon-arrow-down"></i>
                </el-button>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="isShowFabricMore">
          <el-col :span="8">
            <el-form-item v-if="isShowFabricMore" :label="$t('坯布分类')">
              <el-input v-model="searchFabricData.model.type" :placeholder="$t('请输入')" clearable class="inputWidth" @keyup.enter.native="searchFabric" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <span style="color: transparent">{{ $t('占位') }}</span>
          </el-col>
          <el-col :span="8">
            <el-form-item>
              <div class="inputWidth d-flex justify-end" style="margin-top: 32px">
                <el-button v-preventReClick type="primary" @click="searchFabric">
                  {{ $t('查询') }}
                </el-button>
                <el-button v-preventReClick type="default" @click="resetFabric">{{ $t('重置') }}</el-button>
                <el-button type="default" style="margin-right: 0" @click="isShowFabricMore = !isShowFabricMore">
                  {{ $t('收起') }}
                  <i class="el-icon-arrow-up"></i>
                </el-button>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <vxe-grid
        ref="tableRefFabric"
        border
        highlight-hover-row
        highlight-current-row
        resizable
        keep-source
        show-overflow
        show-header-overflow
        :loading="fabricLoading"
        cell-class-name="c-class-style"
        header-row-class-name="h-class-style"
        :columns="tableFabricColumn"
        :data="tableFabricData.records"
        @cell-click="handleFabricClick"
      >
        <template #empty>
          <el-empty :image="require('@/assets/404_images/no-data-small.png')" :description="$t('暂无数据')" />
        </template>
      </vxe-grid>
      <pagination
        v-show="tableFabricData.total > 0"
        :limit.sync="searchFabricData.size"
        :page.sync="searchFabricData.current"
        :total="Number(tableFabricData.total)"
        :popper-class="'select_bottom'"
        @pagination="fetchFabricList"
      />
    </Drawer>
    <!-- 选择颜色弹窗 -->
    <Drawer :title="$t('选择颜色')" :visible="isShowColour" class="drawer" size="1200px" @confirm="confirmDrawer" @closed="closeDrawer">
      <el-form :model="searchColourData.model" class="form-inline-drawer mb-0-5" label-position="top">
        <el-row>
          <el-col :span="8">
            <el-form-item :label="$t('色号')">
              <el-input v-model="searchColourData.model.colourNumber" class="inputWidth" :placeholder="$t('请输入')" clearable @keyup.enter.native="searchColour" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('颜色')">
              <el-input v-model="searchColourData.model.colour" :placeholder="$t('请输入')" class="inputWidth" clearable @keyup.enter.native="searchColour" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item v-if="isShowColourMore" :label="$t('色级')">
              <el-select v-model="searchColourData.model.colourType" :placeholder="$t('请选择')" class="inputWidth">
                <el-option v-for="item in colourTypeOptions" :key="item.value" :label="item.name" :value="item.value" />
              </el-select>
            </el-form-item>
            <el-form-item v-if="!isShowColourMore">
              <div class="inputWidth d-flex justify-end" style="margin-top: 32px">
                <el-button v-preventReClick type="primary" @click="searchColour">
                  {{ $t('查询') }}
                </el-button>
                <el-button v-preventReClick type="default" @click="resetColour">{{ $t('重置') }}</el-button>
                <el-button type="default" style="margin-right: 0" @click="isShowColourMore = !isShowColourMore">
                  {{ $t('更多') }}
                  <i class="el-icon-arrow-down"></i>
                </el-button>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="isShowColourMore">
          <el-col :span="8">
            <el-form-item v-if="isShowColourMore" :label="$t('敏感色')">
              <el-select v-model="searchColourData.model.isSensitiveColor" :placeholder="$t('请选择')" class="inputWidth">
                <el-option :label="$t('是')" :value="true" />
                <el-option :label="$t('否')" :value="false" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <span style="color: transparent">{{ $t('占位') }}</span>
          </el-col>
          <el-col :span="8">
            <el-form-item>
              <div class="inputWidth d-flex justify-end" style="margin-top: 32px">
                <el-button v-preventReClick type="primary" @click="searchColour">
                  {{ $t('查询') }}
                </el-button>
                <el-button v-preventReClick type="default" @click="resetColour">{{ $t('重置') }}</el-button>
                <el-button type="default" style="margin-right: 0" @click="isShowColourMore = !isShowColourMore">
                  {{ $t('收起') }}
                  <i class="el-icon-arrow-up"></i>
                </el-button>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <vxe-grid
        ref="tableRefColour"
        border
        highlight-hover-row
        highlight-current-row
        resizable
        keep-source
        show-overflow
        show-header-overflow
        :loading="colourLoading"
        cell-class-name="c-class-style"
        header-row-class-name="h-class-style"
        :columns="tableColourColumn"
        :data="tableColourData.records"
        @cell-click="handleColourClick"
      >
        <template #empty>
          <el-empty :image="require('@/assets/404_images/no-data-small.png')" :description="$t('暂无数据')" />
        </template>
        <!-- 色值 -->
        <template v-slot:colourValue="{ row }">
          <el-tooltip v-if="row.colourValue" placement="bottom">
            <div slot="content">{{ $t('色值') + ': ' + row.colourValue }}</div>
            <div class="d-flex justify-center align-center pointer" style="width: 24px; height: 24px; margin-top: 4px; border: 1px solid #e5e6eb">
              <div :style="`width:16px;height:16px;background-color:${row.colourValue};`"></div>
            </div>
          </el-tooltip>
        </template>
        <template v-slot:isSensitiveColor="{ row }">
          {{ row.isSensitiveColor ? $t('是') : $t('否') }}
        </template>
      </vxe-grid>
      <pagination
        v-show="tableColourData.total > 0"
        :limit.sync="searchColourData.size"
        :page.sync="searchColourData.current"
        :total="Number(tableColourData.total)"
        :popper-class="'select_bottom'"
        @pagination="fetchColourList"
      />
    </Drawer>
  </div>
</template>

<script>
import { initQueryParams } from '@klinx/utils/commons';
import { baseColorApi, baseCustomerApi, baseCommonApi, baseFabricApi } from '@klinx/base/src/api/index.js';
export default {
  props: {
    // 选择的类型0:置空，1:客户，2:坯布，3:颜色
    showType: {
      type: String,
      default: '0'
    }
  },
  data() {
    return {
      // 选择色号
      colourLoading: false,
      isShowColourMore: false,
      isShowColour: false,
      tableColourData: { records: [], total: 0 },
      searchColourData: initQueryParams({
        model: {},
        size: 20
      }),
      tableColourColumn: [
        {
          fixed: 'left',
          type: 'radio',
          width: 50,
          align: 'center'
        },
        {
          field: 'colourNumber',
          title: this.$t('色号'),
          minWidth: 100
        },
        {
          field: 'colour',
          title: this.$t('颜色'),
          minWidth: 100
        },
        {
          field: 'colourAtla',
          title: this.$t('色卡号'),
          minWidth: 100
        },
        {
          field: 'colourEnglishName',
          title: this.$t('潘通色卡'),
          minWidth: 100
        },
        {
          field: 'colourValue',
          title: this.$t('色值'),
          minWidth: 60,
          slots: {
            default: 'colourValue'
          }
        },
        {
          field: 'colourTypeName',
          title: this.$t('色级'),
          minWidth: 100
        },
        {
          field: 'isSensitiveColor',
          title: this.$t('敏感色'),
          minWidth: 100,
          slots: { default: 'isSensitiveColor' }
        },
        {
          field: 'updateTime',
          title: this.$t('更新时间'),
          minWidth: 150
        }
      ],
      // 选择坯布
      fabricLoading: false,
      isShowFabricMore: false,
      isShowFabric: false,
      tableFabricData: { records: [], total: 0 },
      searchFabricData: initQueryParams({
        model: {},
        size: 20
      }),
      tableFabricColumn: [
        {
          fixed: 'left',
          type: 'radio',
          width: 50,
          align: 'center'
        },
        {
          field: 'code',
          title: this.$t('坯布号'),
          minWidth: 100
        },
        {
          field: 'name',
          title: this.$t('坯布品名'),
          minWidth: 300
        },
        {
          field: 'component',
          title: this.$t('成分'),
          minWidth: 100
        },
        {
          field: 'type',
          title: this.$t('坯布分类'),
          minWidth: 100
        },
        {
          field: 'updateTime',
          title: this.$t('更新时间'),
          minWidth: 150
        }
      ],
      // 选择客户弹窗
      customerLoading: false,
      isShowCustomerMore: false,
      isShowCustomer: false,
      tableCustomerData: { records: [], total: 0 },
      searchCustomerData: initQueryParams({
        model: {},
        size: 20
      }),
      tableCustomerColumn: [
        {
          fixed: 'left',
          type: 'radio',
          width: 50,
          align: 'center'
        },
        {
          field: 'code',
          title: this.$t('客户编码'),
          minWidth: 100
        },
        {
          field: 'nickname',
          title: this.$t('客户名称'),
          minWidth: 100
        },
        {
          field: 'name',
          title: this.$t('客户全称'),
          minWidth: 100
        },
        {
          field: 'groupName',
          title: this.$t('客户分组'),
          minWidth: 100
        },
        {
          field: 'businessPerson',
          title: this.$t('业务员'),
          minWidth: 100
        },
        {
          field: 'content',
          title: this.$t('描述'),
          minWidth: 150
        }
      ]
    };
  },
  watch: {
    showType(val) {
      if (val === '1') {
        this.isShowCustomer = true;
      } else if (val === '2') {
        this.isShowFabric = true;
      } else if (val === '3') {
        this.isShowColour = true;
      }
    }
  },
  mounted() {
    this.fetchCustomerList(); // 客户列表
    this.fetchFabricList(); // 坯布列表
    this.getColourType(); //  色级
    this.fetchColourList(); // 颜色列表
  },
  methods: {
    // 取消弹窗
    closeDrawer() {
      this.isShowCustomer = false;
      this.isShowColour = false;
      this.isShowFabric = false;
      // if (this.showType === '1') {
      //   this.$refs.tableRefCustomer.clearRadioRow();
      // } else if (this.showType === '2') {
      //   this.$refs.tableRefFabric.clearRadioRow();
      // } else if (this.showType === '3') {
      //   this.$refs.tableRefColour.clearRadioRow();
      // }
      this.$emit('closeDrawerSelect');
    },
    // 确认选择
    confirmDrawer() {
      if (this.showType === '1') {
        // 选择客户确定
        if (this.$refs.tableRefCustomer.getRadioRecord() === null) {
          this.$message.info(this.$t('请选择客户！'));
          return false;
        }
        this.isShowCustomer = false;
        this.$emit('confirmDrawerSelect', this.$refs.tableRefCustomer.getRadioRecord());
      } else if (this.showType === '2') {
        if (this.$refs.tableRefFabric.getRadioRecord() === null) {
          this.$message.info(this.$t('请选择坯布！'));
          return false;
        }
        this.isShowFabric = false;
        this.$emit('confirmDrawerSelect', this.$refs.tableRefFabric.getRadioRecord());
      } else if (this.showType === '3') {
        if (this.$refs.tableRefColour.getRadioRecord() === null) {
          this.$message.info(this.$t('请选择颜色！'));
          return false;
        }
        this.isShowColour = false;
        this.$emit('confirmDrawerSelect', this.$refs.tableRefColour.getRadioRecord());
      }
    },
    // 选择颜色
    handleColourClick({ row }) {
      this.$refs.tableRefColour.setRadioRow(row);
    },
    searchColour() {
      this.fetchColourList();
    },
    resetColour() {
      this.searchColourData.model = {};
      this.fetchColourList();
    },
    // 查字典色级
    getColourType() {
      baseCommonApi.getDictCodes({ 'codes[]': 'RMS_COLOR_LEVEL' }).then((response) => {
        const res = response.data.data;
        this.colourTypeOptions = res.RMS_COLOR_LEVEL.map((item) => {
          return {
            name: item.name,
            value: item.val
          };
        });
      });
    },
    fetchColourList() {
      this.colourLoading = true;
      baseColorApi
        .getColourPage(this.searchColourData)
        .then((response) => {
          const res = response.data;
          if (res.isSuccess) {
            this.tableColourData = res.data;
          } else {
            this.$message.info(res.msg);
          }
        })
        .finally(() => {
          this.colourLoading = false;
        });
    },
    // 选择坯布
    handleFabricClick({ row }) {
      this.$refs.tableRefFabric.setRadioRow(row);
    },
    searchFabric() {
      this.fetchFabricList();
    },
    resetFabric() {
      this.searchFabricData.model = {};
      this.fetchFabricList();
    },
    fetchFabricList() {
      this.fabricLoading = true;
      baseFabricApi
        .getFabricList(this.searchFabricData)
        .then((response) => {
          const res = response.data;
          if (res.isSuccess) {
            this.tableFabricData = res.data;
          } else {
            this.$message.info(res.msg);
          }
        })
        .finally(() => {
          this.fabricLoading = false;
        });
    },
    // 选择客户
    handleCustomerClick({ row }) {
      this.$refs.tableRefCustomer.setRadioRow(row);
    },
    searchCustomer() {
      this.fetchCustomerList();
    },
    resetCustomer() {
      this.searchCustomerData.model = {};
      this.fetchCustomerList();
    },
    fetchCustomerList() {
      this.customerLoading = true;
      baseCustomerApi
        .getCustomerListNew(this.searchCustomerData)
        .then((response) => {
          const res = response.data;
          if (res.isSuccess) {
            this.tableCustomerData = res.data;
          } else {
            this.$message.info(res.msg);
          }
        })
        .finally(() => {
          this.customerLoading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.form-inline-drawer {
  .inputWidth {
    width: 375px !important;
  }
  ::v-deep {
    .el-form-item--small.el-form-item {
      margin-bottom: 8px !important;
      .el-form-item__label {
        padding-bottom: 0 !important;
      }
    }
    .el-form-item__label {
      color: #86909c;
    }
    .el-form-item--small {
      margin-right: 0;
    }
  }
}
::v-deep {
  .c-class-style {
    font-weight: 400;
    font-size: 13px;
    color: #1d2129;
  }
  .h-class-style {
    height: 32px !important;
    background: #f7f8fa;
  }
  .vxe-header--column .vxe-cell--title {
    line-height: 32px;
  }
  .vxe-table--render-default .vxe-body--column:not(.col--ellipsis),
  .vxe-table--render-default .vxe-footer--column:not(.col--ellipsis),
  .vxe-table--render-default .vxe-header--column:not(.col--ellipsis) {
    padding: 0 0;
  }
  .vxe-table--render-default .vxe-body--column.col--ellipsis,
  .vxe-table--render-default.vxe-editable .vxe-body--column,
  .vxe-table--render-default .vxe-footer--column.col--ellipsis,
  .vxe-table--render-default .vxe-header--column.col--ellipsis,
  .c--tooltip {
    height: 32px;
    line-height: 32px;
  }
  .vxe-header--column.col--ellipsis > .vxe-cell .vxe-cell--title {
    font-size: 13px;
    color: #1d2129;
  }
}
</style>
